import { Table } from "@/features/Table";
import { type StrategyChild, strategy_children_columns } from "./columns";
import {
  type FilterStrategyChildrenSchema,
  FilterStrategyChildren,
} from "./filter";
import { useLocation } from "react-router-dom";

const client = "legacy-quantilia";
const table_name = "strategy_children";

export const StrategyChildrenTable = () => {
  const location = useLocation();
  const baseUrl = location.pathname;

  return (
    <Table<StrategyChild, FilterStrategyChildrenSchema>
      label="Strategy Children"
      client={client}
      table_name={table_name}
      columns={strategy_children_columns}
      filter={<FilterStrategyChildren />}
      disable_translations_request={true}
      actions={[
        {
          label: "actions.new",
          route: `${baseUrl}/new`,
        },
      ]}
    />
  );
};
